import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Growl } from "primereact/growl";
import { RecuperarContrasena } from './RecuperarContrasena';
import { Message } from 'primereact/message';
import servicioObjetos from "../servicio/ServicioObjetos";
import { autenticar } from '../servicio/ServicioAutenticacion';

import { deleteToken, deleteUsuario } from "../servicio/ServicioManejadorToken";

export default class Login extends Component {
  constructor() {
    super();
    this.state = {
      usuario: {},
      mostralModal: false,
      recuperar: {},
      errores: {},
      mostrarContrasenas: false,
    };
    deleteToken();
    deleteUsuario();
  }

  login = () => {
    deleteToken();
    deleteUsuario();
    let { usuario } = this.state;
    let validacion = this.validarForm(usuario);
    this.setState({ errores: validacion });
    if (servicioObjetos.esObjetoVacio(validacion)) {
      autenticar(usuario.usuario, usuario.contrasena).then(response => {
        this.props.history.push("/idsenube/bienvenido");
      }).catch(error => {
        this.growl.show({ severity: "error", summary: "", detail: error });
      });
    }
  };

  asignarValores = (event) => {
    servicioObjetos.asignarAtributosObjeto(event, this, false);
  };

  validarForm = (valor) => {
    const errores = {};
    if (servicioObjetos.esObjetoVacio(valor.usuario))
      errores.usuario = "El campo usuario es requerido";
    if (servicioObjetos.esObjetoVacio(valor.contrasena))
      errores.contrasena = 'El campo contraseña es requerido';
    return errores;
  };

  mostrarContrasena() {
    var cambio = document.getElementById("usuario.contrasena");
    if (cambio.type === "password") {
      cambio.type = "text";
    } else {
      cambio.type = "password";
    }
  }

  eventoKeyPress = (evento) => {
    if (evento.key === 'Enter') {
      this.login();
    }
  }

  render() {
    const { usuario, errores} = this.state;
    return (
      <div className="login-body">
        <Growl ref={(el) => (this.growl = el)} />
        <div className="login-type">
          <div className="card login-panel p-fluid">
            <div className="p-grid">
              <div className="p-col-12">              
                <img src="assets/layout/images/logo.png" style={{ marginLeft:"-76px" }}  alt=""/>                
              </div>
              <div className="p-col-12">
                <span className="md-inputfield">
                  <InputText
                    className={errores.usuario ? "p-error" : ""}
                    id="usuario.usuario"
                    name="usuario.usuario"
                    value={usuario.usuario || ""}
                    onChange={this.asignarValores}
                    onKeyPress={this.eventoKeyPress}
                  />
                  <label>* Usuario</label>
                  {errores.usuario ? <div><Message severity="error" text={errores.usuario} /> </div> : null}
                </span>
              </div>
              <div className="p-col-12 p-md-8">
                <span className="md-inputfield p-input-icon-right">
                  <InputText
                    ref={el => this.password = el}
                    className={errores.contrasena ? "p-error" : ""}
                    id="usuario.contrasena"
                    name="usuario.contrasena"
                    value={usuario.contrasena || ""}
                    onChange={this.asignarValores}
                    type="password"
                    onKeyPress={this.eventoKeyPress}
                  />
                  <label>* Contraseña</label>
                  {errores.contrasena ? <div><Message severity="error" text={errores.contrasena} /> </div> : null}
                </span>
              </div>

               <div className="p-col-12 p-md-3">
                <Button
                  onClick={this.mostrarContrasena}
                  icon="pi-md-remove-red-eye" />
              </div>

              <div className="p-col-12">
                <Button label="Iniciar sesión" icon="pi-md-person" onClick={this.login} />
                <RecuperarContrasena />                
              </div>
              <div className="p-col-12">
               <div style={{color:"#757575"}}>Envío Masivo al IMSS y Confronta Automática</div> 
              </div>
            </div>
          </div>
        </div>        
      </div>
    );
  }
}